<style lang="scss" scoped>
/* 信息项目，工程项目专用 */
 /deep/.custom-select .el-input__inner{
    height: auto !important;
    background-color: #fafafa;
    border: none;
}
.deviceItemStyle{
    padding:1px 5px;
    background-color: #ebf5ff;
	border-radius: 4px;
	border: solid 1px rgba(64, 158, 255, 0.5);
}
</style>

<template>
    <el-table-column
        :prop="col.prop"
        :label="col.label"
        align="center"
        v-if="!col.show"
        :fixed="col.fixed"
		:width="col.width"
        :height="height"
        :render-header="renderHeader"
        >
        <template v-if="col.children && !col.show">
            <multi-type-column-for-info
                v-for="(item, index) in col.children"
                :key="index"
                :col="item"
                :noCommafyList="noCommafyList"
                :editField="editField"
				:width="width"
                :height="height"
                :unEditRow="unEditRow"
                :required ="required"
                :editFieldType="editFieldType"
                :pasteField="pasteField"
                :editFildHide="editFildHide"
                :formatterList="formatterList"
                :tableData="tableData"
                 @modification="modification"
                @pasteData="pasteData">
            </multi-type-column-for-info>
             <el-input />
        </template>
        <template slot-scope="scope">
            <el-input @paste.native="onPaste(scope.$index,col.prop)"  @focus='getfocus("text",$event,scope,col,scope.$index)' @blur.prevent="dblur('text',$event,scope.row,col.prop)" v-model="scope.row[col.prop]"  
            v-if="editField.indexOf(col.prop) != -1 && editFieldType[editField.indexOf(col.prop)]=='text' && !isNoEditRow && !col.noNeedControl&&unEditRow.indexOf(scope.$index)== -1" placeholder="请输入" :maxlength="100" size="small"  type="text" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)"/>
            <!-- 整数 -->
            <el-input @paste.native="onPaste(scope.$index,col.prop)"  @focus='getfocus("text",$event,scope,col,scope.$index)' @blur.prevent="dblur('text',$event,scope.row,col.prop)" v-model="scope.row[col.prop]"  
            v-if="editField.indexOf(col.prop) != -1 && editFieldType[editField.indexOf(col.prop)]=='number' && !isNoEditRow && !col.noNeedControl&&unEditRow.indexOf(scope.$index)== -1" placeholder="请输入" :maxlength="100" size="small"  type="text" v-on:input="inputFunc1(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)"/>
            <el-input @paste.native="onPaste(scope.$index,col.prop)"  @focus='getfocus("text",$event,scope,col,scope.$index)' @blur.prevent="dblur('text',$event,scope.row,col.prop)" v-model="scope.row[col.prop]"  
            v-if="editField.indexOf(col.prop) != -1 && editFieldType[editField.indexOf(col.prop)]=='text' && !isNoEditRow && col.noNeedControl&&unEditRow.indexOf(scope.$index)== -1" placeholder="请输入" :maxlength="100" size="small"  :value="strGetVal(col.prop,scope)" /> 
            <el-select 
                class="custom-select"
                style="height:100%" 
                v-model="scope.row[col.prop]"  
                @paste.native="onPaste(scope.$index,col.prop)"                  
                @change="e=>col.on.change(e,scope.$index,scope.row)" 
                ref="selectRef" 
                v-if="
                    editField.indexOf(col.prop) != -1 && 
                    editFieldType[editField.indexOf(col.prop)]=='select' && 
                    !isNoEditRow && !col.noNeedControl&&
                    unEditRow.indexOf(scope.$index)== -1
                "        
                placeholder="请选择">                
                <el-option
                    v-for="item in assetsTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name">
                </el-option>
            </el-select>

            <el-date-picker @paste.native="onPaste(scope.$index,col.prop)" v-else-if="editField.indexOf(col.prop) != -1  && editFieldType[editField.indexOf(col.prop)]=='date'"
            @focus='getfocus("date",$event,scope,col,scope.$index)' @blur="dblur('date',$event,scope.row,col.prop)"
                v-model="scope.row[col.prop]"
                style="width: 100%"
                type="date"
                value-format="timestamp"
                :picker-options="scope.row.pickerOptions"
                placeholder="请选择"
                :editable="false"
                prefix-icon="return fasle">
            </el-date-picker>
            <span  v-if="editField.indexOf(col.prop) == -1||unEditRow.indexOf(scope.$index)!= -1">
                <span class="bm bm-ac bm-pc" style="height:100%;color: #323232;">{{strGetVal(col.prop,scope)}}</span>
            </span>
        </template>
    </el-table-column>
</template>

<script>
import { money,numberFormat } from "@/utils/filter.js"
export default {
    name: "multi-type-column-for-info",
    data() {
        return {
            sth:"",
            field:[],
            computedField:{},
            focusIndex:"",//聚焦在哪一行
            focusProp:""
        };
    },
    props: {
        bitian:{
            type: Boolean
        },
        tableData:{
            type: Array
		},
        col: {
            type: Object
        },
        editField:{
            type: Array,
            default:function(){
                return []
            }
        },
        editFieldType:{
            type: Array
        },
		width:{
			type: String
		},
		height:{
			type: String
        },
        required:{
            type: Boolean
        },
        newInvestmentTotalIsReadOnly:{          
            type: Boolean,
            default: false
        },
        formatterList:{
            type: Array
        },
        editFildHide:{
            type: Array,
            default:function(){
                return []
            }
        },
        noCommafyList:{
            type: Array,
            default:function(){
                return []
            }
        },
        
        unEditRow:{
            type: Array
        },
        isNoEditRow:{
            type:Boolean
        },
        pasteField:{
            type: Array
        },
        isInfoReadOnly:{
            type:Boolean
        }
    },
    data() {
        return {
            assetsTypeList:[]
        }
    },
    created(){
        this.assetsTypeList = this.$store.state.init.configInfo.unsetupAssetType
    },
    methods: {
        //去除采购需求
        questMove(index,rowData){
			this.$emit("questMove",index,rowData);
        },
        // render 事件
		renderHeader (h,{column}) { // h即为cerateElement的简写，具体可看vue官方文档
			// 当需要显示tip信息时
			if( this.col.isShowTip ){
				return h('div',{style:'display:flex;justify-content:center'},[ 
					// h('span', {style:'color:#323232,position:fixed,top:0,left:0,background-color:#fed11b'},'我是tip'),
					h('span', column.label),
					h('tipDialog', {
						props:{
							message:{
								tipInfo:"预计中标价默认给出公发部的意见，如有异议请修改",
								title:column.label
							}
						}
					})
				])
			}
            if(this.required&&this.bitian==false) {
                if(this.editField.indexOf(column.property) != -1 && this.editFildHide.indexOf(column.property) == -1) {
                	return h('div',{style:'display:flex'},[ 
                        h('span', {style:'color:#ff0101'},'*'),
                        h('span', column.label)
                    ])
				}else {
                    return column.label;
                }
            }else {
                return column.label;
            }
            
            
        },
        //获取到焦点
        getfocus(type,e,scope,col,index,x){
            console.log("获取焦点============", col.prop);
            let that =this;
            let rowprop = eval('scope.row.'+col.prop );
            // let rowprop =e.target.value;
            this.focusIndex = index;
            this.focusProp = col.prop;
            if(type == 'date'){
                e.$el.children[0].className = 'get-focus el-input__inner';
                return
            }else{
                e.target.className = 'get-focus el-input__inner';
                e.target.type="number";
            }
            that.$nextTick(()=>{
                setTimeout(()=>{
                    e.target.type="text";
                    console.log("1",rowprop)
                    if(rowprop && !col.noNeedControl){
                        console.log("去除千分位数据",rowprop)
                        // e.target.value = that.delcommafy(rowprop);
                        e.target.value = money(rowprop);
                    } else if(col.noNeedControl) {
                         e.target.value = rowprop
                    }
                    e.target.selectionStart = e.target.value.length;
                },30);
            });
        },
        //失去焦点
        dblur(type,e,row,prop){
            console.log("失去焦点");
            const rowprop = eval('row.'+prop );
            if(type == 'date'){ 
                e.$el.children[0].className = 'el-input__inner';
                this.$nextTick(()=>{
                    if(rowprop){                
                        e.$el.children[0].value = moment(parseInt(rowprop)).format('YYYY-MM-DD');
                    }
                });
            } else{
                if(JSON.stringify(this.noCommafyList).indexOf(prop)==-1){
                    // e.target.value = this.commafy(e.target.value);
                    e.target.value = money(e.target.value);
                }
                e.target.className = 'el-input__inner';
                e.target.type="text";
            }
            this.computedField = {row:row,prop:prop};
            this.$root.$emit("loseFocus", this.computedField);
        },
         //去除千分位
        delcommafy(num){
            if((num+"").trim()==""){
                return num;
            }
            num = num+"";
            num=num.replace(/,/gi,'');
            console.log("打印数据---------------",num)
            return num;
        },
        // 数字格式转换成千分位
        commafy(num){
            if((num+"").trim()=="" || isNaN(num) || num == null){
                return num;
            }
            num = num+"";
            if(/^.*\..*$/.test(num)){
            let pointIndex =num.lastIndexOf(".");
            let intPart = num.substring(0,pointIndex);
            let pointPart =num.substring(pointIndex+1,num.length);
            intPart = intPart +"";
                let re =/(-?\d+)(\d{3})/
                while(re.test(intPart)){
                intPart =intPart.replace(re,"$1,$2")
                }
            num = intPart+"."+pointPart;
            }else{
                num = num +"";
                let re =/(-?\d+)(\d{3})/
                while(re.test(num)){
                num =num.replace(re,"$1,$2")
                }
            }
            return num;
        },
        //输入监听 index下标 row 一行数据 prop 属性 e值 新数组
        inputFunc(index,row,prop,e){
            console.log("实时监听数据===============");
            // scope.$index, scope.row,col.prop,$event
            console.log(index,row,prop,e);
            //防滚鼠标
            let that = this;
            e = numberFormat(e,{ start:100,end:2});
            eval('row.'+prop+"= e" );
            console.log(that.tableData !=undefined,that.tableData ,undefined)
            if(that.tableData !=undefined){
                var new_arr = JSON.parse(JSON.stringify(that.tableData));
                new_arr[index] = row;
                //回掉事件
                that.$emit("modification", {index:index,row:row,prop:prop,val:e,tableData:new_arr});
            }
        },
        //输入监听 index下标 row 一行数据 prop 属性 e值 新数组
        inputFunc1(index,row,prop,e){
            console.log("实时监听数据===============");
            // scope.$index, scope.row,col.prop,$event
            console.log(index,row,prop,e);
            //防滚鼠标
            let that = this;
            e = numberFormat(e,{ start:100,end:0});
            eval('row.'+prop+"= e" );
            console.log(that.tableData !=undefined,that.tableData ,undefined)
            if(that.tableData !=undefined){
                var new_arr = JSON.parse(JSON.stringify(that.tableData));
                new_arr[index] = row;
                //回掉事件
                that.$emit("modification", {index:index,row:row,prop:prop,val:e,tableData:new_arr});
            }
        },
        strGetVal(row,scope){
            if(this.formatterList && this.formatterList.indexOf(scope.column.property) != -1) {//日期格式化
                let dataStr = eval('scope.row.'+row );
                if(dataStr){
                    return moment(parseInt(dataStr)).format('YYYY-MM-DD');
                }else{
                    return "";
                }
			}else if(this.formatteColumn && this.formatteColumn.name.indexOf(scope.column.property) != -1){
				return  this.formatteColumn.list[eval('scope.row.'+row )-1];
			}else if(row == "sfSales"){
                if(scope.row.sfSales){
                    if(scope.row.sfSales == "0"){
                        return "未上市";
                    }else{
                        return "已上市";
                    }
                }
            }else if(row == "assetType"){ // assetType 选择框
                const find = this.assetsTypeList.find(v=>v.id == scope.row.assetType)
                if(find){
                    return find.name
                } else {
                    return ""
                }
            }else{
                if((this.focusIndex == scope["$index"] && this.editField.indexOf(this.focusProp) != -1) || row == 'materialCode'){
                    return  eval('scope.row.'+row);
                }else{
                    if(JSON.stringify(this.noCommafyList).indexOf(row)==-1){
                        return this.commafy(eval('scope.row.'+row ))
                    }else{
                        return  eval('scope.row.'+row);
                    }
                }
            }
        },
        substrClipTest(clipText,data){
            let index = clipText.indexOf("\r\n");
            if(index > -1){
                let rowResult = clipText.slice(0,index).split("\t");
                data.push(rowResult);
                let text = clipText.slice(index+2);
                if(text.indexOf("\r\n") > -1){
                     this.substrClipTest(text,data);
                }
                return data;
            }
        },
        onPaste(index,prop){
            //如果不满足 黏贴列表传空pasteField=[]
            if(this.pasteField&&this.pasteField.length>0){
                navigator.clipboard.readText().then((clipText)=>{//
                    //  console.log(clipText)
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]); 
                        let editData = []; 
                        //2.结果集处理成对象 类型，字段名，内容
                        result.forEach((value,key)=>{
                            let data = [];
                            let startVal =false,i=0;
                            this.pasteField.forEach((editValue,editKey)=>{
                                if((editValue.name == prop || startVal)&&value[i]!=undefined){//2个字段相等就开始， 直到数组遍历完
                                    startVal =true;
                                    let obj={type:editValue.type,key:editValue.name,value:value[i],isCover:editValue.isCover};
                                    data.push(obj);
                                    i++;
                                }
                            });
                            editData.push(data);
                        });
                        // debugger
                        console.log("结果集",editData)
                        //3.结果集 写入到表里面
                        editData.forEach((value,key)=>{
                            value.forEach((innerValue,innerKey)=>{
                                    //每种类型的处理
                                    if(innerValue.isCover){
                                        // console.log("onPaste index: "+index+", key: "+key+", value: "+value+", innerKey: "+innerKey+", innerValue: "+innerValue)
                                        let tableDataItem=this.tableData[index+key];
                                        if(undefined!=tableDataItem){
                                            if(innerValue.type == "number"){
                                                this.$set(tableDataItem,innerValue.key,parseFloat(innerValue.value));

                                            }else if(innerValue.type == "date"){
                                                this.$set(tableDataItem,innerValue.key,moment(innerValue.value).valueOf());
                                                
                                            }else{                                                
                                                this.$set(tableDataItem,innerValue.key,innerValue.value);
                                            }
                                        }
                                        else{
                                            console.log("onPaste outof range.  index: "+index+", key: "+key)
                                        }
                                        
                                    }
                                    
                                
                            });
                        });
                        // debugger
                        //公共处理
                        this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result});
                    }
                });
            }else{
                 navigator.clipboard.readText().then((clipText)=>{//
                    //  console.log(clipText)
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]); 
                        //自己处理
                        this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result});
                    }
                });
            }
            
        },
        pasteData(e){
            this.$emit("pasteData",e);
        },
         //input 监听 index下标 row 一行数据 prop 属性 val值 新数组tableData
        modification(e) {
            // this.tableDataBpc=R.clone(rowobj.tableData);
           this.$emit("modification", e);
        }
    }
};
</script>
